"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostClientEdit = void 0;
const Base_1 = require("./Base");
exports.PostClientEdit = {
    url: Base_1.URL_BASE + "/ClientEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostClientEdit.js.map